export default {
    model: {
        prop: 'modalShow',
        event: 'change'
    },
    props: {
        modalShow: {
            'type': Boolean,
            'default': false,
            'required': true
        }
    },
    
    data() {
        return {
            modalVisible: false
        };
    },
    watch: {
        modalShow: function (newVal) {
            this.modalVisible = newVal;
        },
        modalVisible: function (newVal) {
            this.$emit('change', newVal);
        }
    }
};
